function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3329 12.1051H16.6705C15.4332 12.1051 14.2464 12.5968 13.3714 13.4717C12.4965 14.3466 12.0049 15.5334 12.0049 16.7707V26.1019C12.0037 28.6075 12.6753 31.0677 13.9493 33.2251C15.2234 35.3826 17.0532 37.1586 19.2479 38.3678C21.4426 39.5769 23.9217 40.1745 26.4263 40.0985C34.0406 39.8653 39.9985 33.4221 39.9985 25.8032V16.7706C39.9985 15.5333 39.5069 14.3465 38.632 13.4715C37.757 12.5966 36.5703 12.105 35.3329 12.105L35.3329 12.1051ZM36.266 25.85C36.266 31.4067 31.9503 36.1469 26.3982 36.3662C24.5522 36.4376 22.7211 36.0095 21.0981 35.1268C19.4752 34.2441 18.1205 32.9398 17.1767 31.3515C16.2332 29.763 15.736 27.9495 15.7374 26.1019V16.7707C15.7374 16.5233 15.8356 16.2859 16.0107 16.1109C16.1857 15.9358 16.4231 15.8376 16.6705 15.8376H35.3329C35.5803 15.8376 35.8177 15.9358 35.9926 16.1109C36.1677 16.2859 36.266 16.5233 36.266 16.7707L36.266 25.85Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.657 21.052C23.3858 21.7808 23.3858 22.9624 22.657 23.6913C21.9283 24.4201 20.7465 24.4201 20.0178 23.6913C19.289 22.9624 19.289 21.7808 20.0178 21.052C20.7465 20.3232 21.9283 20.3232 22.657 21.052Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9891 21.0504C32.718 21.7793 32.718 22.961 31.9891 23.6897C31.2603 24.4186 30.0787 24.4186 29.3499 23.6897C28.621 22.961 28.621 21.7793 29.3499 21.0504C30.0787 20.3217 31.2603 20.3217 31.9891 21.0504Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0733 27.4131C26.7913 28.1532 25.2121 28.1532 23.9302 27.4131C23.5019 27.1179 22.9698 27.0149 22.462 27.1288C21.9544 27.2429 21.5175 27.5637 21.2566 28.0138C20.9957 28.464 20.9345 29.0025 21.0877 29.4996C21.2409 29.9968 21.595 30.4075 22.0639 30.6324C23.2677 31.3346 24.6362 31.7045 26.0297 31.7045C27.4233 31.7045 28.7918 31.3346 29.9954 30.6324C30.4646 30.4075 30.8185 29.9968 30.9718 29.4996C31.1251 29.0025 31.0639 28.464 30.8029 28.0138C30.542 27.5637 30.1051 27.2429 29.5974 27.1288C29.0898 27.0149 28.5576 27.1179 28.1292 27.4131H28.0733Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPerformance);
export default __webpack_public_path__ + "static/media/show_performance.117e5e80ccde3f1b23a7e65295a7bb13.svg";
export { ForwardRef as ReactComponent };